export default "__VITE_ASSET__6molTgqb__"